var render = function render(){var _vm=this,_c=_vm._self._c;return _c('styled-a',{attrs:{"href":_vm.url,"target":"_blank","aria-label":_vm.alt}},[_c('card',[_c('logo',{attrs:{"src":_vm.src,"alt":_vm.alt}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }